import React from 'react'
import './Notificaciones.css'
import { MiFooter } from '../../components/footer/MiFooter';
import Header from '../../components/headers/Header';
import { ContentBodyNotificaciones } from '../../components/noTificaciones/ContentBodyNotificaciones'
import { useContext } from 'react'
import { UsuarioContext } from '../../contexts/UsuarioContext'

export const Notificaciones = () => {

  const [MenuLateral, setMenuLateral] = useContext(UsuarioContext)
  const closeMenu = () => {
    if (MenuLateral === true) {
      setMenuLateral(false)
    }
  }
  return (
    <div className='miNotificaciones' onClick={closeMenu} >
      <div className='headerNotificaciones'>
        <Header />
      </div>
      <div className="bodyNotificaciones">
        <ContentBodyNotificaciones />
      </div>
      <div className='footerNotificaciones'>
        <MiFooter />
      </div>
    </div>
  )
}
